import { FormEvent, useState } from "react";
import ConfirmDialog from "components/popup/ConfirmDialog";
import { CommentDataProps } from "hooks/console/useGetConsoleQrSystemDetail";

type CommentProps = {
    adminOnly?: boolean;
    commentData: CommentDataProps[];
    postComment: (value: string, successCallback: () => void) => void;
    deleteComment: (value: string) => void;
    updateComment: (cListNo: string, content: string, successCallback: () => void) => void;
};

type CommentItemProps = {
    data: CommentDataProps;
    deleteComment: (value: string) => void;
    updateComment: (cListNo: string, content: string, successCallback: () => void) => void;
};

const CommentItem = ({ data, deleteComment, updateComment }: CommentItemProps) => {
    const [value, setValue] = useState(data.c_content);
    const [editMode, setEditMode] = useState(false);

    return (
        <div className="border-t py-[12px] flex flex-col gap-y-2">
            <div className="flex items-center justify-between">
                <div className="flex gap-2 items-center">
                    <span className="text-[#1A2448] font-bold min-w-[60px]">{data.c_name}</span>
                    <span className="text-[#999999] text-[14px]">
                        {data.c_wdate.substring(5, 10) + " " + data.c_wdate.substring(11, 16)}
                    </span>
                </div>
                <div className="flex">
                    <button
                        className="font-[400] text-[#8A8A8A] text-[14px] border-none px-2 leading-[12px]"
                        style={{ borderRight: "1px solid #dddddd" }}
                        onClick={() =>
                            editMode ? updateComment(data.c_list_no.toString(), value, () => setEditMode(false)) : setEditMode(true)
                        }
                    >
                        {editMode ? "저장" : "수정"}
                    </button>

                    <ConfirmDialog
                        title="코멘트 삭제"
                        trigger={open => (
                            <button
                                type="button"
                                onClick={() => {
                                    open();
                                }}
                                className="font-[400] text-[#8A8A8A] text-[14px] border-none px-2 leading-[12px]"
                            >
                                삭제
                            </button>
                        )}
                        handleConfirm={() => deleteComment(data.c_list_no.toString())}
                    />
                </div>
            </div>
            {editMode ? (
                <textarea
                    name=""
                    id=""
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    className="border border-[#dddddd] rounded-[8px] p-3 flex gap-2 min-h-[100px]"
                />
            ) : (
                <p className="whitespace-pre text-[#666666]">{data.c_content}</p>
            )}
        </div>
    );
};
export default function Comment({ adminOnly = false, commentData, postComment, deleteComment, updateComment }: CommentProps) {
    const [value, setValue] = useState("");

    const onSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        postComment(value, () => setValue(""));
    };

    return (
        <div className="flex flex-col gap-y-2">
            <p className="text-[#1A2448] text-[18px] font-bold">댓글</p>
            <form
                onSubmit={onSubmit}
                className="border border-[#dddddd] rounded-[8px] p-3 flex gap-2 min-h-[100px] [&:has(textarea:focus)]:ring-2"
            >
                <textarea
                    name="comment"
                    id="comment"
                    className="flex-1 resize-none outline-none"
                    placeholder="코멘트를 달아 주세요."
                    value={value}
                    onChange={e => setValue(e.target.value)}
                />
                <button className="mt-auto text-[#4F46E5] font-bold">작성</button>
            </form>
            {adminOnly && <p className="text-[#666666] text-right text-[14px] mb-2">*관리자만 볼 수 있는 댓글입니다.</p>}

            {commentData?.map(data => {
                return <CommentItem key={data.c_list_no} data={data} deleteComment={deleteComment} updateComment={updateComment} />;
            })}
        </div>
    );
}
